export const environment = {
  appName: 'FINEXWORD',
  appVersion: '1.1.6',
  production: false,
  serverUrl: 'https://stage-1.finexword.com',
  contentUrl: 'https://finexword.com/api'
}
